import React, { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useConfig } from "./configContext/ConfigContext.component";
import { ApiService } from "../api/api.service";

const ApiInitializerLayer: React.FC = ({ children }) => {
  const { oktaAuth } = useOktaAuth();
  const config = useConfig();
  const api = ApiService.getInstance();

  useEffect(() => {
    if (!api.oktaAuth) {
      api.oktaAuth = oktaAuth;
    }

    if (config && !api.appConfig) {
      api.appConfig = config;
      api.initializeAPIs();
    }
  }, [api, config, oktaAuth]);

  return <>{children}</>;
};

export default ApiInitializerLayer;
